import { PureComponent, Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { AvField, AvForm } from 'availity-reactstrap-validation';

import {
  Button,
  Icon,
  Modal,
  Tab,
  Dropdown,
  Grid,
  Divider,
  Segment,
  Search,
} from 'semantic-ui-react';

import { get, debounce } from '../../../../utils/lodash';
import { authMsg } from '../../../../utils/auth';

import {
  getOutputFormatGroups,
  getOutputFormats,
  postOutputFormatGroup,
  postOutputFormat,
  updateOutputFormatGroup,
  updateOutputFormat,
  deleteOutputFormatter,
} from '../../../../store/actions';

import { CustomTable } from '../../../../components';
import { isBetaLaunchAdminEmail } from '../../../../utils/constant';
import CopyText from '../../../../components/copyText';
import { OutputFormatForm } from './outputFormatForm';

class FormatGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      fields: [],
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async componentDidMount() {
    const { getOutputFormatGroups } = this.props;
    getOutputFormatGroups();
  }

  render() {
    const { modal } = this.state;
    const { adminOutputFormatLoading, t } = this.props;

    return (
      <Fragment>
        <div className="outcome-admin p-4">
          <div className="button-outcome">
            <Modal
              open={modal}
              onOpen={() => this.toggle()}
              closeIcon={
                <Icon
                  onClick={() => this.toggle()}
                  name="close"
                  className="closeicon"
                />
              }
              size="large"
              trigger={
                <button className="submit-button">
                  <Icon name="plus circle" />
                  {t(
                    'admin.activity_settings.output_formatters.add_format_groups'
                  )}
                </button>
              }
            >
              <Modal.Header>
                {t(
                  'admin.activity_settings.output_formatters.create_output_format_group'
                )}
              </Modal.Header>
              <Modal.Content>
                <OutputFormatGroupForm
                  toggle={() => this.toggle()}
                  {...this.props}
                />
              </Modal.Content>
            </Modal>
          </div>
        </div>

        <Segment loading={adminOutputFormatLoading}>
          <OutputFormatGroupList {...this.props} />
        </Segment>
      </Fragment>
    );
  }
}
class Format extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      fields: [],
      currentPage: 1,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  componentDidMount() {
    const { getOutputFormats } = this.props;
    getOutputFormats();
  }

  pageChange = (page) => {
    const { getOutputFormats } = this.props;
    getOutputFormats(page);
    this.setState({ currentPage: page });
  };

  handleSearchChange = (e, { value }) => {
    const { getOutputFormats } = this.props;
    getOutputFormats(1, value);
    this.setState({ currentPage: 1 });
  };

  render() {
    const { adminOutputFormatLoading, t } = this.props;
    const { modal, currentPage } = this.state;
    const loggedUserEmail = get(this.props, 'auth.user.email', null);
    const isBetaLaunchAdmin = isBetaLaunchAdminEmail(loggedUserEmail);

    return (
      <Fragment>
        <div className="outcome-admin">
          <div className="mr-auto">
            <Search
              className="search-bar-custom"
              placeholder={t(
                'admin.activity_settings.output_formatters.search_by_name_or_field'
              )}
              showNoResults={false}
              onSearchChange={debounce(this.handleSearchChange, 500)}
            />
          </div>

          <div className="button-outcome">
            {isBetaLaunchAdmin ? (
              <Modal
                open={modal}
                onOpen={() => this.toggle()}
                closeIcon={
                  <Icon
                    onClick={() => this.toggle()}
                    name="close"
                    className="closeicon"
                  />
                }
                size="small"
                trigger={
                  <button className="submit-button">
                    <Icon name="plus circle" />
                    {t(
                      'admin.activity_settings.output_formatters.add_output_format'
                    )}
                  </button>
                }
              >
                <Modal.Header>
                  {t(
                    'admin.activity_settings.output_formatters.create_output_format'
                  )}
                </Modal.Header>
                <Modal.Content>
                  <OutputFormatForm
                    toggle={() => this.toggle()}
                    pageChange={this.pageChange}
                    {...this.props}
                  />
                </Modal.Content>
              </Modal>
            ) : (
              <></>
            )}
          </div>
        </div>

        <Segment loading={adminOutputFormatLoading}>
          <OutputFormatList
            isBetaLaunchAdmin={isBetaLaunchAdmin}
            currentPage={currentPage}
            pageChange={this.pageChange}
            {...this.props}
          />
        </Segment>
      </Fragment>
    );
  }
}
class OutputFormatGroupForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      outputFormatOptions: [],
      outputFormatDropdownValues: [],
      outputFormats: [],
      isOutputformtsInvalid: false,
    };
  }

  componentDidMount() {
    const { outputFormatsList, outputFormatGroup, t } = this.props;
    console.log('outputFormatsList', outputFormatsList, outputFormatGroup);
    const options = outputFormatsList.docs.map((outputFormat) => ({
      key: outputFormat.id,
      text: (
        <span>
          {outputFormat.label}{' '}
          {outputFormat.isFormula && (
            <span className="formula-label">
              {t('admin.activity_settings.output_formatters.formula')}
            </span>
          )}
        </span>
      ),
      value: outputFormat.id,
    }));

    const newState = {
      outputFormatOptions: options,
    };

    if (outputFormatGroup) {
      const outputFormatDropdownValues = [];
      const outputFormats = [];

      for (let i = 0; i < outputFormatGroup.outputFormat.length; i++) {
        const format = outputFormatGroup.outputFormat.find(
          (format) => format.order === i + 1
        );
        if (format) {
          outputFormats.push({
            ...format.formatDetails,
            formula: format.formula ? format.formula : '',
          });
          outputFormatDropdownValues.push(format.formatDetails.id);
        }
      }

      newState.outputFormats = outputFormats;
      newState.outputFormatDropdownValues = outputFormatDropdownValues;
    }

    this.setState(newState);
  }

  handleValidSubmit(event, values) {
    const {
      postOutputFormatGroup,
      updateOutputFormatGroup,
      outputFormatGroup,
      toggle,
    } = this.props;
    const { outputFormats } = this.state;

    if (outputFormats.length === 0) {
      this.setState({ isOutputformtsInvalid: true });
      return;
    }

    values.outputFormats = outputFormats.map((outputFormat, index) => {
      delete values[`formula${index}`];
      if (outputFormat.formula) {
        return { id: outputFormat.id, formula: outputFormat.formula };
      }
      // A formula output left blank becomes a plain input for this format
      // only; send null so the server clears any saved formula (TAK-2070).
      return outputFormat.isFormula
        ? { id: outputFormat.id, formula: null }
        : { id: outputFormat.id };
    });

    if (outputFormatGroup) {
      values.id = outputFormatGroup.id;
      updateOutputFormatGroup(values);
    } else {
      postOutputFormatGroup(values);
    }

    toggle();
  }

  outputFormatDropdownOnChange(values) {
    const { outputFormats, outputFormatDropdownValues } = this.state;
    const { t, outputFormatsList, outputFormatGroup } = this.props;

    let newOutputFormats = [...outputFormats];
    let newOutputFormatDropdownValues = [...outputFormatDropdownValues];

    values.forEach((value) => {
      const isExist = outputFormats.find(
        (outputFormat) => outputFormat.id === value
      );

      if (isExist) return;

      const formatObject = outputFormatsList.docs.find(
        (outputFormat) => outputFormat.id === value
      );
      newOutputFormatDropdownValues.push(value);
      newOutputFormats.push(formatObject);
    });

    outputFormats.forEach((outputFormat) => {
      const isExist = values.find((value) => outputFormat.id === value);

      if (isExist) return;

      if (outputFormatGroup) {
        const isAllradySaved = outputFormatGroup.outputFormat.find(
          (format) => format.outputFormatId === outputFormat.id
        );
        if (isAllradySaved) {
          authMsg(
            'error',
            t('output_formats.errors.not_possible_to_delete_previously_saved')
          );
          return;
        }
      }
      newOutputFormatDropdownValues = newOutputFormatDropdownValues.filter(
        (value) => outputFormat.id !== value
      );
      newOutputFormats = newOutputFormats.filter(
        (item) => outputFormat.id !== item.id
      );
    });

    this.setState({
      outputFormats: newOutputFormats,
      outputFormatDropdownValues: newOutputFormatDropdownValues,
      isOutputformtsInvalid: false,
    });
  }

  handleOnDragEnd(result) {
    if (!result.destination || this.props.view) return;

    const { outputFormats } = this.state;
    const items = Array.from(outputFormats);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    const dropdownItems = items.map((item) => item.id);

    this.setState({
      outputFormats: items,
      outputFormatDropdownValues: dropdownItems,
    });
  }

  formulaOnChange(value, index) {
    const { outputFormats } = this.state;
    const newOutputFormats = [...outputFormats];
    newOutputFormats[index].formula = value;
    this.setState({ outputFormats: newOutputFormats });
  }

  renderOutputFormatCard(outputFormat, index) {
    const { t } = this.props;
    return (
      <Grid className="output-format-drag-contianer">
        <Grid.Row columns={3}>
          <Grid.Column className="label-contianer">
            <label>{t('formulary.label')}</label>
            <label className="draggable-card-title mb-0">
              {outputFormat.label}
            </label>
          </Grid.Column>
          <Grid.Column className="label-contianer">
            <label>{t('formulary.field_name')}</label>
            <label className="draggable-card-title mb-0">
              {outputFormat.name}
              <CopyText text={outputFormat.name} />
            </label>
          </Grid.Column>
          <Grid.Column className="label-contianer">
            <label>{t('common.type')}</label>
            <label className="draggable-card-title mb-0">
              {get(outputFormat, 'typeData.name', '-')}
            </label>
          </Grid.Column>
        </Grid.Row>
        {outputFormat.isFormula && (
          <Grid.Row columns={1}>
            <Grid.Column className="label-contianer">
              <AvField
                label={t('admin.activity_settings.output_formatters.formula')}
                name={`formula${index}`}
                disabled={this.props.view}
                value={outputFormat.formula}
                onChange={(event, value) => this.formulaOnChange(value, index)}
                rows="2"
                type="textarea"
                placeholder={`${t('output_formats.enter_formula_here')}...`}
                // Optional (TAK-2070): leave blank for a plain number field.
                validate={{
                  pattern: {
                    value: '^\\S*$',
                    errorMessage: t(
                      'admin.activity_settings.output_formatters.formula_no_whitespace'
                    ),
                  },
                }}
              />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    );
  }

  render() {
    const { outputFormatGroup, view, t } = this.props;
    const {
      outputFormatOptions,
      outputFormats,
      outputFormatDropdownValues,
      isOutputformtsInvalid,
    } = this.state;

    let form = {};
    if (outputFormatGroup) {
      form = {
        name: outputFormatGroup.name,
      };
    }

    return (
      <AvForm
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        autoComplete="off"
        model={form}
      >
        <AvField
          label={t('common.group_name')}
          name="name"
          type="text"
          disabled={view}
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.group_name_required'),
            },
          }}
        />
        {!view && (
          <div>
            <label>{t('formulary.output_format')}</label>
            <Dropdown
              placeholder={t('formulary.placeholder.select_output_format')}
              className="output-format-dropdown"
              fluid
              multiple
              value={outputFormatDropdownValues}
              search
              selection
              options={outputFormatOptions}
              onChange={(event, { value }) =>
                this.outputFormatDropdownOnChange(value)
              }
            />
            {isOutputformtsInvalid && (
              <label className="custom-error-label">
                {t('formulary.validation.output_format_required')}
              </label>
            )}
          </div>
        )}

        {view ? (
          outputFormats.map((outputFormat, index) => (
            <div key={index}>
              <Divider />
              {this.renderOutputFormatCard(outputFormat, index)}
            </div>
          ))
        ) : outputFormats.length === 0 ? (
          <div className="output-format-drag-contianer empty">
            <label>
              {t('formulary.placeholder.please_select_output_format')}
            </label>
          </div>
        ) : (
          <div style={{ minHeight: '200px' }}>
            <DragDropContext onDragEnd={(value) => this.handleOnDragEnd(value)}>
              <Droppable
                droppableId="outputFormats"
                renderClone={(provided, snapshot, rubric) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                  >
                    {this.renderOutputFormatCard(
                      outputFormats[rubric.source.index],
                      rubric.source.index
                    )}
                  </div>
                )}
              >
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {outputFormats.map((outputFormat, index) => (
                      <Draggable
                        key={outputFormat.id}
                        draggableId={`${outputFormat.id}`}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Divider />
                            <div>
                              <label className="draggable-card-title">
                                {index + 1}) {outputFormat.label}
                              </label>
                            </div>
                            {this.renderOutputFormatCard(outputFormat, index)}
                            {provided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}

        <div className="model-button mt-4">
          {view ? (
            <Button
              content={t('actions.close')}
              type="submit"
              className="modal-proceed mr-0"
              onClick={() => this.props.toggle()}
            />
          ) : (
            <Button
              content={t('actions.save')}
              type="submit"
              className="modal-proceed mr-0"
              // loading={outLoading}
              // disabled={outLoading}
            />
          )}
        </div>
      </AvForm>
    );
  }
}
class OutputFormatGroupList extends PureComponent {
  constructor(props) {
    super(props);
    const { t, i18n } = this.props;
    this.state = {
      currentPage: 1,
    };
    this.columns = [
      {
        width: 4,
        title: t('common.group_name'),
        render: (data) => {
          return data.name;
        },
      },
      {
        width: 4,
        title: t('common.date_created'),
        render: (data) => {
          return new Intl.DateTimeFormat(i18n.language, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          }).format(new Date(data.createdAt));
        },
      },
      {
        width: 4,
        title: t('common.last_update'),
        render: (data) => {
          return new Intl.DateTimeFormat(i18n.language, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          }).format(new Date(data.updatedAt));
        },
      },
      {
        width: 4,
        title: '',
        render: (data) => (
          <div className="output-format-action">
            <ViewOutputFormatGroup {...this.props} outputFormatGroup={data} />
            <EditOutputFormatGroup {...this.props} outputFormatGroup={data} />
            <RemoveOutputFormatter {...this.props} item={data} group />
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    const { getOutputFormats } = this.props;
    getOutputFormats('all');
  }

  pageChange = (page) => {
    const { getOutputFormatGroups } = this.props;
    getOutputFormatGroups(page);
    this.setState({ currentPage: page });
  };

  render() {
    const { outputFormatGroupsList, listLoading, t } = this.props;

    return (
      <CustomTable
        header
        columns={this.columns}
        data={outputFormatGroupsList.docs}
        emptyMessage={t(
          'empty_message.you_have_not_created_any_output_formats_yet'
        )}
        customClass="output-format-table"
        // pagination
        handlePaginationChange={this.pageChange}
        // page={this.state.currentPage}
        // noOfPages={outputFormatGroupsList.pages}
      />
    );
  }
}
class OutputFormatList extends PureComponent {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.columns = [
      {
        width: this.props.isBetaLaunchAdmin ? 5 : 8,
        title: t('admin.activity_settings.output_formatters.label_name'),
        render: (data) => {
          return (
            <p>
              {data.label}{' '}
              {data.isFormula && (
                <span className="formula-label">
                  {t('admin.activity_settings.output_formatters.formula')}
                </span>
              )}
            </p>
          );
        },
      },
      {
        width: 5,
        title: t('admin.activity_settings.output_formatters.field_name'),
        isCopyEnabled: true,
        render: (data) => {
          return data.name;
        },
      },
      {
        width: this.props.isBetaLaunchAdmin ? 3 : 5,
        title: t('common.type'),
        render: (data) => {
          return get(data, 'typeData.name', '-');
        },
      },
      {
        width: 3,
        title: '',
        render: (data) =>
          this.props.isBetaLaunchAdmin ? (
            <div className="output-format-action">
              <EditOutputFormat
                pageChange={this.pageChange}
                {...this.props}
                outputFormat={data}
              />
              <RemoveOutputFormatter
                pageChange={this.pageChange}
                {...this.props}
                item={data}
              />
            </div>
          ) : (
            <></>
          ),
      },
    ];
  }

  render() {
    const { outputFormatsList, pageChange, currentPage, t } = this.props;
    return (
      <CustomTable
        header
        columns={this.columns}
        data={outputFormatsList.docs}
        emptyMessage={t(
          'admin.activity_settings.output_formatters.no_output_formats_yet'
        )}
        customClass="output-format-table"
        pagination
        handlePaginationChange={pageChange}
        page={currentPage}
        noOfPages={outputFormatsList.pages}
      />
    );
  }
}
class RemoveOutputFormatter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      loading: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  async handleOutputFormatRemove() {
    this.setState({ loading: true });
    const { deleteOutputFormatter, item, group } = this.props;
    await deleteOutputFormatter(item.id, `${group ? 'group' : 'format'}`);
    this.toggle();
    this.setState({ loading: false });
  }

  render() {
    const { modal, loading } = this.state;
    const { group, t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        closeIcon={<Icon name="close" className="closeicon" />}
        size="mini"
        trigger={
          <label className="activity-actions-error first-down ">
            {t('actions.delete')}
          </label>
        }
      >
        <Modal.Header>
          {t('admin.activity_settings.output_formatters.delete_confirmation')}
        </Modal.Header>
        <Modal.Content>
          <p>
            {group
              ? t(
                  'admin.activity_settings.output_formatters.delete_output_format_group_confirm'
                )
              : t(
                  'admin.activity_settings.output_formatters.delete_output_format_confirm'
                )}
          </p>

          <div className="model-button">
            <Button onClick={() => this.toggle()} className="modal-cancel">
              {t('actions.no')}
            </Button>
            <Button
              onClick={() => {
                this.handleOutputFormatRemove();
                if (!group) {
                  this.props.pageChange(1);
                }
              }}
              content={t('actions.delete')}
              type="submit"
              className="modal-proceed"
              loading={loading}
              disabled={loading}
            />
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
class EditOutputFormat extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  componentDidMount() {
    const { outputFormat } = this.props;
    this.setState({ form: outputFormat });
  }

  handleValidSubmit(event, values) {}

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        closeIcon={<Icon name="close" className="closeicon" />}
        size="small"
        trigger={
          <label className="activity-actions-warn mb-0">
            {t('actions.edit')}
          </label>
        }
      >
        <Modal.Header>
          {t('admin.activity_settings.output_formatters.edit_output_format')}
        </Modal.Header>
        <Modal.Content>
          <OutputFormatForm
            isEdit={true}
            toggle={() => this.toggle()}
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}
class EditOutputFormatGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        size="large"
        trigger={
          <label className="activity-actions-warn mb-0">
            {t('actions.edit')}
          </label>
        }
      >
        <Modal.Header>
          {t('admin.activity_settings.output_formatters.edit_format_group')}
        </Modal.Header>
        <Modal.Content>
          <OutputFormatGroupForm toggle={() => this.toggle()} {...this.props} />
        </Modal.Content>
      </Modal>
    );
  }
}
class ViewOutputFormatGroup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }
  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;

    return (
      <Modal
        open={modal}
        onOpen={() => this.toggle()}
        onClose={() => this.toggle()}
        closeIcon={<Icon name="close" className="closeicon" />}
        size="small"
        trigger={
          <label className="activity-actions-warn mb-0">
            {t('actions.view')}
          </label>
        }
      >
        <Modal.Header>
          {t('admin.activity_settings.output_formatters.view_format_groups')}
        </Modal.Header>
        <Modal.Content>
          <OutputFormatGroupForm
            toggle={() => this.toggle()}
            view
            {...this.props}
          />
        </Modal.Content>
      </Modal>
    );
  }
}

class OutputFormatter extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {};
    this.panes = [
      {
        menuItem: t('admin.activity_settings.output_formatters.format_group'),
        render: () => <FormatGroup {...this.props} />,
      },
      {
        menuItem: t('output_formats.format'),
        render: () => <Format {...this.props} />,
      },
    ];
  }

  render() {
    return (
      <Tab
        menu={{ color: 'orange', secondary: true, pointing: true }}
        panes={this.panes}
        className="custom-tab"
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    adminOutputFormatLoading: state.admin.adminOutputFormatLoading,
    outputFormatsList: state.admin.outputFormatsList,
    outputFormatGroupsList: state.admin.outputFormatGroupsList,
    outputFormatterUpdateLoading: state.admin.outputFormatterUpdateLoading,
    outLoading: state.admin.outLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOutputFormatGroups,
      getOutputFormats,
      postOutputFormatGroup,
      postOutputFormat,
      updateOutputFormatGroup,
      updateOutputFormat,
      deleteOutputFormatter,
    },
    dispatch
  );
};

OutputFormatter = withTranslation()(OutputFormatter);
OutputFormatter = connect(mapStateToProps, mapDispatchToProps)(OutputFormatter);

export { OutputFormatter };
